import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/ml-settings'

interface Endpoints {
  getHosts: NoParamEndpointConstructor
  getEndpoints: NoParamEndpointConstructor
  getEngines: NoParamEndpointConstructor
}

export const mlSettingsEndpoints: Endpoints = {
  getHosts: () => `${baseUrl}/hosts`,
  getEndpoints: () => `${baseUrl}/endpoints`,
  getEngines: () => `${baseUrl}/engines`,
}
